import React from 'react';
import PipelinesTable from './PipelinesTable';

const OpportunityPipelines = () => {
    return <PipelinesTable stage={"opportunity"} />
}

export default OpportunityPipelines;